'use client'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import LoginForm from '@/app/(auth)/signin/LoginForm'
import { LogInIcon } from 'lucide-react'
import { cn } from '@/services/utils/cn'
import { useAuth } from '@/services/providers/auth-provider'
import { createContext, useContext, useState } from 'react'

// create a signin provider
interface SignInContext {
  openDialog: () => void
  closeDialog: () => void
  isOpen: boolean
}

export const SignInContext = createContext<SignInContext | null>(null)

export function SignInProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const auth = useAuth()

  const openDialog = () => setIsOpen(true)
  const closeDialog = () => setIsOpen(false)

  return (
    <SignInContext.Provider value={{ openDialog, closeDialog, isOpen }}>
      <Dialog
        open={auth.isAuthenticated() ? false : isOpen}
        onOpenChange={setIsOpen}
      >
        <DialogTitle className="sr-only">คุณต้องเข้าสู่ระบบก่อน</DialogTitle>
        <DialogContent className="overflowy-y-auto h-auto w-[90vw] text-center">
          <LoginForm />
        </DialogContent>
        {children}
      </Dialog>
    </SignInContext.Provider>
  )
}

export const useSignIn = () => {
  const context = useContext(SignInContext)
  if (!context) {
    throw new Error('useSignIn must be used within a SignInProvider')
  }
  return context
}

export function SignInButton() {
  const auth = useAuth()
  const { openDialog } = useSignIn()

  return (
    <button
      className={cn(
        auth.isAuthenticated() && 'hidden',
        'relative z-50 flex gap-2 rounded-full border border-black bg-black px-4 py-2 font-line text-base text-white hover:underline'
      )}
      onClick={openDialog}
    >
      เข้าสู่ระบบ
      <LogInIcon className="h-5 w-5" />
    </button>
  )
}
